<title>{{ functionalCapabilitiesOrderManagementPage.htmlTitle }}</title>
<div *ngIf="isTab || isTabOverride" class="">
  <ul class="d-flex nav-bar">
    <li *ngFor="let tab of apiTabs; let i = index" class="tab-link bgdgry"
      [ngClass]="selectedIndex === i ? 'border-blue' : 'border-darkblack'" (click)="selectedIndex = i">
      <a class="nav-link active" data-bs-toggle="tab" (click)="setPageTitle(apiName + ' ' + tab)">
        <i [ngClass]="apiTabsClass[i]"></i>
        {{ tab }}</a>
    </li>
  </ul>
</div>
<!-- Tab panes -->
<div class="tab-content">
  <app-functional-capabilities-introduction-section
    [sections]="functionalCapabilitiesOrderManagementPage.sections"></app-functional-capabilities-introduction-section>
</div>